import { Moon, Sun, Monitor } from 'lucide-react'
import { useUIStore } from '@/shared/stores/uiStore'
import { Button } from '@/shared/components/ui/button'

export function ThemeToggle() {
  const { theme, setTheme } = useUIStore()
  
  const toggleTheme = () => {
    if (theme === 'light') setTheme('dark')
    else if (theme === 'dark') setTheme('system')
    else setTheme('light')
  }
  
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      title={`Theme: ${theme}`}
      className="text-muted-foreground hover:text-foreground"
    >
      {theme === 'light' && <Sun className="h-[18px] w-[18px]" />}
      {theme === 'dark' && <Moon className="h-[18px] w-[18px]" />}
      {theme === 'system' && <Monitor className="h-[18px] w-[18px]" />}
    </Button>
  )
}

export default ThemeToggle
